import React, { useState } from 'react';
import { mockData } from '../mock';
import { useContent } from '../context/ContentContext';
import { useT } from '../context/LanguageContext';
import { EditButton } from './admin/EditorShell';
import { SchemaEditor } from './admin/SchemaEditor';
import { pictureUrl } from '../lib/api';

const SCHEMA = [
  { key: 'name', label: 'Namn' },
  { key: 'code', label: 'Liten tekst over namnet (valfritt)' },
  { key: 'url', label: 'Nettside (valfritt)', type: 'url' },
  { key: 'logo', label: 'Logo (valfritt)', type: 'image' },
];

const Sponsors = () => {
  const { content } = useContent();
  const { t } = useT();
  const [editing, setEditing] = useState(false);
  const sponsors = content.sponsors || mockData.sponsors.map((s) => ({ id: s.code, ...s }));
  return (
    <section id="partnere" className="bg-black py-20 md:py-28 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="relative mb-12">
          <h2 className="text-5xl md:text-7xl font-black text-white tracking-tighter text-center" style={{ fontFamily: "'Oktah Round', sans-serif" }}>{t('Sponsorar')}</h2>
          <div className="absolute right-0 top-1/2 -translate-y-1/2"><EditButton onClick={() => setEditing(true)} testId="edit-sponsors-button" /></div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="sponsors-grid">
          {sponsors.map((s) => {
            const Tag = s.url ? 'a' : 'div';
            return (
              <Tag key={s.id || s.name} {...(s.url ? { href: s.url, target: '_blank', rel: 'noreferrer noopener' } : {})} className="group aspect-square rounded-2xl bg-[#1a1424] border border-white/5 flex flex-col items-center justify-center p-6 hover:border-[#ff2e2e] hover:-translate-y-1 transition-all">
                {s.logo ? (
                  <img src={pictureUrl(s.logo)} alt={s.name} loading="lazy" className="max-h-20 w-auto max-w-[80%] object-contain mb-3" />
                ) : (
                  s.code && <span className="text-white/30 font-mono text-xs mb-3">{s.code}</span>
                )}
                <span className={`${s.logo ? 'text-base' : 'text-3xl md:text-4xl'} font-black text-white group-hover:text-[#ff2e2e] transition-colors tracking-tight text-center`} style={{ fontFamily: "'Oktah Round', sans-serif" }}>{s.name}</span>
              </Tag>
            );
          })}
        </div>
      </div>
      {editing && <SchemaEditor contentKey="sponsors" title="Rediger sponsorar" initial={sponsors} schema={SCHEMA} itemLabel="sponsor" onClose={() => setEditing(false)} />}
    </section>
  );
};

export default Sponsors;
